'use client';

import { FC, memo, useId, useRef } from 'react';
import { usePageTransition } from '../use-page-transition';
export const ProgressBarIndicator: FC = memo(() => {
  const progressBarId = useId();
  const progressBarRef = useRef<HTMLDivElement>(null);
  usePageTransition(status => {
    const progressBar = progressBarRef.current;
    if (!progressBar) {
      return;
    }
    if (status === 'ready') {
      progressBar.style.transitionDuration = '100ms';
      progressBar.style.width = '102%';

      // show the progress bar for a short time before hiding it (better UX)
      setTimeout(() => {
        progressBar.style.transitionDuration = '0s';
        progressBar.style.width = '0%';
      }, 500);
      return;
    }
    progressBar.style.transitionDuration = '60s';
    progressBar.style.width = '90%';
  });
  return <>
      <div className="fixed left-0 right-0 top-0 z-[9999] overflow-hidden">
        <div
      // this elements gets modified even before the client is hydrated
      // so we need to suppress the hydration warning
      suppressHydrationWarning id={progressBarId} ref={progressBarRef} className="h-1.5 rounded-r-full bg-secondary-marine-100" style={{
        width: '0%',
        transitionProperty: 'width',
        transitionDuration: '60s',
        transitionTimingFunction: 'cubic-bezier(0.01, 0.95, 0.05, 0.95)'
      }} />
      </div>
      <script type="text/javascript" dangerouslySetInnerHTML={{
      // custom script to immediately starts the progress bar even before the client is hydrated
      __html: `
            const progressBar = document.getElementById("${progressBarId}");

            if(progressBar) {
              setTimeout(() => progressBar.style.width = "90%", 10);
            }
            `
    }} />
    </>;
});
ProgressBarIndicator.displayName = 'ProgressBarIndicator';